<template>
    <div class="z-10 flex w-full flex-row items-center gap-x-2 p-2 font-sans">
        <div class="m-0 w-full p-0">
            <div class="flex w-full items-start">
                <div class="h-3 w-full overflow-hidden rounded-[2px] border border-gray-500 bg-gray-100">
                    <div role="progressbar"
                        name="Rating bar"
                        aria-label="Rating bar"
                        aria-valuemin="1"
                        aria-valuemax="5"
                        class="h-full w-[var(--width)] bg-[#f6ca6c] transition-all duration-500 ease-in-out"
                        :style="{
                            '--width': `${width}%`
                        }"
                    ></div>
                </div>
            </div>
        </div>

        <p class="w-6 text-black">{{ count }}</p>
    </div>
</template>

<script setup lang="ts">
const properties = defineProps<{
    count: number
    totalRatingCount: number
}>();

const getBarWidth = (count: number, totalRatings: number) => {
    if (totalRatings === 0) return 0;
    const barWidth = (count === 0 && totalRatings > 0) ? 0 : Math.round((count / totalRatings) * 100);
    return barWidth > 100 ? 100 : barWidth;
};

const totalRatings = properties.totalRatingCount;
const width = getBarWidth(properties.count, totalRatings);
</script>

<style scoped>

</style>
